import rentStructure from './rent_contract/index';

export default ({
  rentContract: rentStructure(),
});
